import { Component, OnInit, Optional, Inject } from '@angular/core';
import { CompanyMaintenanceService } from '../company-maintenance.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService, LanguageService } from 'src/app/services';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { retry, catchError, finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import { of as observableOf } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'esc-company-maintenance-filter',
  templateUrl: './company-maintenance-filter.component.html',
  styleUrls: ['./company-maintenance-filter.component.scss']
})
export class CompanyMaintenanceFilterComponent implements OnInit {
 
  loading = {
    industry: false,
  }
  public getMore = true;
  public defaultOption = {
    code: "all",
    description: "All"
  };
  public industries = [];
  statuses = [
    {
      code: null,
      description: "All",
    },
    {
      code: 1,
      description: "Active",
    },
    {
      code: 0,
      description: "Inactive",
    },
  ];

  constructor(
    private fb: FormBuilder,
    public media: MediaObserver,
    public companyMntService: CompanyMaintenanceService,
    private dialogService: DialogService,
    private languageService: LanguageService,
    public dialogRef: MatDialogRef<CompanyMaintenanceFilterComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  public formGroup: FormGroup;
  public industryRequired;
  networkErrMsg = this.languageService.getTranslation("MESSAGE_ERROR_NETWORK_CONNECTION", {});

  ngOnInit() {
    this.initForm();
  }

  compareWithFunc = (a: any, b: any) => (a && b) ? a.code == b.code : null;

  initForm() {
    this.formGroup = this.fb.group({
      industry: [_.get(this.data, 'category') || this.defaultOption, Validators.required],
      status: [_.get(this.data, 'status') || this.statuses[0], Validators.required]
    })
  }

  getData(ev) {
    let filters = _.get(ev, 'filters')

     filters.limit = 50
     filters.offset = 0
     filters.keyword = ""

    /*
    * lagay mo dito kung merong i-cascade na parameters for each field
    */
   
    this[_.get(ev, 'arrayName')] = [];

    this.getMore = false;
   
    switch (_.get(ev, 'name')) {
      case "industry": {
        this.loading.industry = true;
        filters.keyword = _.get(this.formGroup.get('industry'), 'value')
        this.companyMntService.getIndustries(filters).pipe(
          retry(-1),
          catchError((err) => {
            this.loading.industry = false;
            this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_ERROR_LOADING", {}));
            return observableOf(err);
          }),
          finalize(() => {
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            if (!environment.production) {
              console.log(res);
            }
            this.loading.industry = false;
            if (res == null || res.status == 0 || res.status == 504 || res.status == 500) {
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            //get more if response isn't empty
            if (_.has(res, 'data') && res.data.length > 0) {
              // gagamitin lang kung may "All"
              if(!this.formGroup.get('industry').value) {
                this.industries[0] = this.defaultOption;
              }
              this.industries = this.industries.concat(res.data);
              this.getMore = true;
            }
          });
        break;
      }
    }
  }

  industrySelected(ev) {
    // after mamili ni user, dito i-set sa form ung value
    // console.log(ev);
    this.formGroup.get('industry').setValue(ev);
    this.formGroup.get('industry').markAsTouched();
  }
  
  applyFilters() {
    for (let ctrl in this.formGroup.controls) {
      if(!this.formGroup.controls[ctrl].valid) {
        this.formGroup.controls[ctrl].markAsTouched();
      }
    }

    if(this.formGroup.valid) {
      this.dialogRef.close(this.formGroup.value);
    }
  }

  reset() {
    for(let ctrl in this.formGroup.controls) {
      this.formGroup.controls[ctrl].reset(null, {emitEvent: false});
      this.formGroup.controls[ctrl].setValue(this.defaultOption, {emitEvent: false});
      this.formGroup.controls[ctrl].markAsUntouched();
    }
    this.formGroup.get('status').setValue(this.statuses[0]);
  }
}
